import { functions } from "../firebase";

export type YouTubeConnection = {
  connected: boolean;
  channelId?: string;
  channelTitle?: string;
  channelHandle?: string;
  thumbnailUrl?: string;
  scopes?: string[];
  stale?: boolean;
  staleReason?: string | null;
};

export const getYouTubeConnection = async (
  communityId: string
): Promise<YouTubeConnection> => {
  const callable = functions.httpsCallable("youtubeGetConnection");
  const res = await callable({ communityId });
  return res.data as YouTubeConnection;
};

export const startYouTubeAuth = async (
  communityId: string
): Promise<{ url: string }> => {
  const callable = functions.httpsCallable("youtubeStartAuth");
  const res = await callable({ communityId });
  return res.data as { url: string };
};

export const completeYouTubeAuth = async (params: {
  code: string;
  state: string;
}): Promise<YouTubeConnection> => {
  const callable = functions.httpsCallable("youtubeCompleteAuth");
  const res = await callable(params);
  return res.data as YouTubeConnection;
};

export const disconnectYouTube = async (
  communityId: string
): Promise<{ connected: boolean }> => {
  const callable = functions.httpsCallable("youtubeDisconnect");
  const res = await callable({ communityId });
  return res.data as { connected: boolean };
};
